import { Card } from "antd";
import styled from "@emotion/styled";
import { genericStyles } from "../../constant";

const StyledCard = styled(Card, {
  shouldForwardProp: (prop) => prop !== "maxWidth",
})`
  width: 100%;
  max-width: ${({
    // @ts-ignore
    maxWidth,
  }) => maxWidth || "400px"};
  border-radius: 16px;
  border-bottom: 5px solid ${genericStyles.primaryColor};
  border-top: 5px solid ${genericStyles.primaryColor};
  box-shadow: ${genericStyles.boxShadow};
`;

export default StyledCard;
